var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"robin d-flex align-start"},[(_vm.displayRobin)?_c('lottie',{attrs:{"options":_vm.lottieOptions,"height":_vm.height,"width":_vm.width},on:{"animCreated":_vm.handleAnimation}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }